<template>
  <div>
    <div id="onfido-mount"></div>
  </div>
</template>

<script>
  export default {
    name: "idoc",
    components: {
    },
    props: {
      verification: null
    },
    data () {
      return {
        onfidoJWT: null,
        onfidoApplicantId: null
      }
    },
    mounted: function () {
      this.$api.getOnifdoToken({
        firstname: this.verification.firstname,
        lastname: this.verification.lastname,
        dob: this.$service.formatDate(this.verification.dob)
      })
        .then(response => {
          this.onfidoJWT = response.data.jwt
          this.onfidoApplicantId = response.data.applicantID
          var _this = this
          Onfido.init({
            // the JWT token that you generated earlier on
            token: this.onfidoJWT,
            // ID of the element you want to mount the component on
            containerId: 'onfido-mount',
            // ALTERNATIVE: if your integration requires it, you can pass in the container element instead
            // (Note that if `containerEl` is provided, then `containerId` will be ignored)
            //containerEl: '<div id="root" />',
            steps: [
              'document',
              'face',
            ],
    //           steps: [
    // {
    //   type:'welcome',
    //   options:{
    //     title:"Verify your identity",
    //     descriptions:["To verifiy your identity document, please follow the steps on the next screens.","It will only take a couple of minutes."],
    //     nextButton : "Start"
    //     }
    // },
  //   'document',
  //   'face',
  //   'complete'
  // ],

            onComplete: function (data) {
              console.log('everything is complete')
              _this.$emit('idcomplete', _this.onfidoApplicantId)
              // `data` will be an object that looks something like this:
              //
              // {
              //   "document_front": {
              //     "id": "5c7b8461-0e31-4161-9b21-34b1d35dde61",
              //     "type": "passport",
              //     "side": "front"
              //   },
              //   "face": {
              //     "id": "0af77131-fd71-4221-a7c1-781f22aacd01",
              //     "variant": "standard"
              //   }
              // }
              //
              // For two-sided documents like `driving_licence` and `national_identity_card`, the object will also
              // contain a `document_back` property representing the reverse side:
              //
              // {
              //   ...
              //   "document_back": {
              //     "id": "6f63bfff-066e-4152-8024-3427c5fbf45d",
              //     "type": "driving_licence",
              //     "side": "back"
              // }
              //
              // You can now trigger your backend to start a new check
              // `data.face.variant` will return the variant used for the face step
              // this can be used to perform a facial similarity check on the applicant
            },
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
    computed: {
     
    },
    methods: {
    }
  }
</script>

<style>
/* .onfido-sdk-ui-Theme-footer {
  display: none;
} */
</style>